var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"cebcc0d4530d2236af73cea898d4265afe1af2ae"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["nx_planner@smartmonkeyio"]={id:"cebcc0d4530d2236af73cea898d4265afe1af2ae"};
      